import { ContestType } from '@betterpool/api-types/contests-service';

import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';

import TeamPickEmNonScheduledNav from './TeamPickEmNonScheduledNav';
import TeamSurvivorNonScheduledNav from './TeamSurvivorNonScheduledNav';
import PlayerTierNonScheduledNav from './PlayerTierNonScheduledNav';

function GamecenterNonScheduledNav({ contest }: { contest: FullContest }) {
  switch (contest.contest_type) {
    case ContestType.TEAM_PICK_EM:
      return <TeamPickEmNonScheduledNav contest={contest} />;
    case ContestType.TEAM_SURVIVOR:
    case ContestType.PLAYER_SURVIVOR:
      return <TeamSurvivorNonScheduledNav contest={contest} />;
    case ContestType.PLAYER_TIER:
    case ContestType.PLAYER_ONE_AND_DONE:
      return <PlayerTierNonScheduledNav contest={contest} />;
    default:
      return null;
  }
}

export default GamecenterNonScheduledNav;
